<section class="weather">
	<span class="material-symbols-rounded weather__icon" aria-hidden="true">{{ iconName() }}</span>
	@if (avgTemp() !== null) {
		<span class="weather__label weather__label--temp">
			{{ avgTemp() }}°C
		</span>
	}
	<span class="weather__label">{{ label() }}</span>
</section>
